// extracted by mini-css-extract-plugin
export default {"root":"AllCatalogs_root__fHwk5","sidebar":"AllCatalogs_sidebar__uh3my"};